var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content mpr-page" },
    [
      _c("div", { staticClass: "mpr-toolbar-card row-data" }, [
        _c(
          "div",
          { staticClass: "mpr-toolbar-section mpr-toolbar-section--filter" },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "mpr-filter-grid" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "mpr-filter-control",
                    attrs: { placeholder: "Loại khoản", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "category", $$v)
                      },
                      expression: "searchRequest.category",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "Thu", value: "IN" } }),
                    _c("el-option", { attrs: { label: "Hoàn", value: "OUT" } }),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "mpr-search-input",
                  attrs: {
                    placeholder: "Nhập tên khoản thu...",
                    clearable: "",
                  },
                  on: { clear: _vm.handleSearch },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleSearch.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("el-button", {
                            attrs: { icon: "el-icon-search" },
                            on: { click: _vm.handleSearch },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.searchRequest.keyword,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchRequest, "keyword", $$v)
                    },
                    expression: "searchRequest.keyword",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "mpr-toolbar-divider" }),
        _c(
          "div",
          { staticClass: "mpr-toolbar-section mpr-toolbar-section--action" },
          [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "mpr-action-group" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mpr-action-button mpr-action-button--primary",
                    attrs: { type: "success" },
                    on: { click: _vm.openCreateDialog },
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v("\n            Thêm mới\n          "),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "mpr-table-card row-data" }, [
        _vm._m(2),
        _c(
          "div",
          { staticClass: "mpr-table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticClass: "sk-table",
                attrs: {
                  data: _vm.principalRevenueList,
                  border: "",
                  "highlight-current-row": "",
                  "max-height": _vm.$tableMaxHeightSmall,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "STT",
                    type: "index",
                    width: "55",
                    align: "center",
                    index: _vm.indexMethod,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tên khoản thu",
                    prop: "name",
                    "min-width": "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "Mô tả", "min-width": "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("div", [
                            _c(
                              "div",
                              {
                                class: [
                                  "mpr-desc",
                                  {
                                    expanded: _vm.isDescriptionExpanded(row.id),
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(row.description || "—"))]
                            ),
                            _vm.showDescriptionToggle(row.description)
                              ? _c("div", { staticClass: "mpr-desc-toggle" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleDescription(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isDescriptionExpanded(row.id)
                                            ? "Thu gọn"
                                            : "Xem thêm"
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Loại", width: "85", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  row.category === "IN" ? "success" : "danger",
                                size: "mini",
                                effect: "light",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    row.category === "IN" ? "Thu" : "Hoàn"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Đơn giá", width: "145", align: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("span", { staticClass: "mpr-money" }, [
                            _vm._v(_vm._s(_vm.formatMoney(row.price))),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Đơn vị",
                    prop: "unit",
                    width: "90",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "Số lượng", width: "90", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatQuantity(row.quantity)) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Giảm giá", width: "150", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("i", {
                            class: row.discount
                              ? "el-icon-circle-check"
                              : "el-icon-close",
                            style: {
                              color: row.discount ? "#16a34a" : "#dc2626",
                              fontSize: "18px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Áp dụng điểm danh",
                    width: "150",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("i", {
                            class: row.attendance
                              ? "el-icon-circle-check"
                              : "el-icon-close",
                            style: {
                              color: row.attendance ? "#16a34a" : "#dc2626",
                              fontSize: "18px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Thời gian áp dụng",
                    width: "150",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                effect: "plain",
                                type: "info",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.appliedTimeTypeLabel(
                                      row.appliedTimeType
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Thao tác",
                    width: "120",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: { content: "Chỉnh sửa", placement: "top" },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditDialog(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Xóa khoản thu",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "ml-1",
                                attrs: {
                                  type: "danger",
                                  icon: "el-icon-delete",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row.id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mpr-pagination" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.pagination.page,
                "page-sizes": [25, 50, 100, 200],
                "page-size": _vm.pagination.size,
                total: _vm.pagination.total,
                layout: "sizes, prev, pager, next",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.pagination, "size", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.pagination, "size", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handlePageChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("principal-revenue-form-dialog", {
        ref: "formDialog",
        on: { saved: _vm.fetchData },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mpr-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "mpr-card-title" }, [_vm._v("Bộ lọc tìm kiếm")]),
        _c("p", { staticClass: "mpr-card-subtitle" }, [
          _vm._v(
            "\n              Tìm nhanh khoản thu theo tên, loại, phạm vi và trạng thái.\n            "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mpr-card-head mpr-card-head--compact" }, [
      _c("div", [
        _c("p", { staticClass: "mpr-card-title" }, [_vm._v("Tác vụ nhanh")]),
        _c("p", { staticClass: "mpr-card-subtitle" }, [
          _vm._v(
            "\n              Thêm mới khoản dùng để tính toán vào hệ thống.\n            "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mpr-card-head mpr-table-head" }, [
      _c("div", [
        _c("p", { staticClass: "mpr-card-title" }, [
          _vm._v("Danh sách khoản phụ"),
        ]),
        _c("p", { staticClass: "mpr-card-subtitle" }, [
          _vm._v(
            "\n            Quản lý toàn bộ khoản dùng để tính toán: đơn giá, thuế, giảm giá và điểm danh.\n          "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }